import {HiOutlineMail} from 'react-icons/hi'
import {RiMessengerLine} from 'react-icons/ri'
import {FaWhatsapp} from 'react-icons/fa'
import {AiFillLinkedin} from 'react-icons/ai'

const data = [
    {id: 1, icon: <HiOutlineMail/>, link: 'mailto:jos.attard92@gmail.com', label: 'Send me an email'},
    {id: 2, icon: <RiMessengerLine/>, link: 'https://www.messenger.com/t/798773606', label: 'Message me on Messenger'},
    {id: 3, icon: <FaWhatsapp/>, link: 'https://wa.me/+35699321188', label: 'Message me on WhatsApp'},
    {id: 4, icon: <AiFillLinkedin/>, link: 'https://www.linkedin.com/in/josephattard/', label: 'Connect on LinkedIn'},
]

export default data